import { Component, OnInit } from '@angular/core';
import { Router,RouterModule } from '@angular/router';
import { AuthService } from './services/auth.service';
import { BoService } from './services/bo.service';
import { NgZone } from '@angular/core';
import { ViewEncapsulation } from '@angular/core';
import 'jquery';

declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  encapsulation: ViewEncapsulation.None
})

export class AppComponent {
title = 'BO-Wilout-Pay';
constructor(private authService: AuthService,private boService: BoService, private router: Router, private routerModule : RouterModule, private ngZone:NgZone){}

ngOnInit() {
    let t=this;
    $(document).ready(function(){
        var checkTactile=0;
        if('maxTouchPoints' in navigator && navigator.maxTouchPoints > 0){
            checkTactile=1;
        };
        var checkstorage=localStorage.getItem('dataList');
        if(checkstorage==undefined||checkstorage==''){}else{
            var idevent=JSON.parse(checkstorage)['_id'];
            t.boService.getAllLists(idevent).then((data) => {
                if(multievwait==1){
                    slievl=$('.slidevents').children().length;
                    wslime=slievl*365;
                    $('.fdpop,.contblocevents').fadeIn(500);
                    $('.blocevents').css({'opacity':'0.8','transform':'scale(1.0)'});
                    $('.titpast').css({'opacity':'1','transform':'scale(1.0)'});
                    multievwait=0;
                    $('.multievbtn').removeClass('multievbtnclic').html('<i class="far fa-bars"></i>&nbsp; Mes listes de contrôle');
                };
            }).catch(error => {});
        };
        /* var checkstorage2=localStorage.getItem('infoUser');
        if(checkstorage2==undefined||checkstorage2==''){}else{
            t.boService.getInfoUser().then((data) => {
            }).catch(error => {});
        }; */
        /* if((localStorage.getItem('dataUser')!='')&&(JSON.parse(localStorage.getItem('dataUser')).admin)){
            if(JSON.parse(localStorage.getItem('dataUser')).admin==true){
                $('.menubs-9').css({'display':'block'});
            }else{
                $('.menubs-9').css({'display':'none'});
            };
        }else{
            $('.menubs-9').css({'display':'none'}); 
        }; */
        var multievwait=0;
        var slievl=0;
        $('.multievbtn').click(function(){
            openEvents();
        });
        var wslime=0;
        function openEvents(){
            slievl=$('.slidevents').children().length;
            wslime=slievl*365;
            if(slievl==0){
                $('.multievbtn').addClass('multievbtnclic').html('<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="icloadmev" width="80px" height="80px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"> <defs> <linearGradient id="bc2" x1="70%" y1="80%" x2="0%" y2="0%"><stop offset="0%" style="stop-color:#ffffff;"></stop><stop offset="80%" style="stop-color:#ffffff;"></stop></linearGradient> </defs> <circle cx="60.2164" cy="60.2164" r="6.71671" fill="url(#bc2)"> <animate attributeName="cx" values="62.020815280171306;37.97918471982869;62.020815280171306" keyTimes="0;0.5;1" dur="1.9607843137254901s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" repeatCount="indefinite" begin="0.6535947712418301s"></animate> <animate attributeName="cy" values="62.020815280171306;37.979184719828694;62.020815280171306" keyTimes="0;0.5;1" dur="1.9607843137254901s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" repeatCount="indefinite" begin="0.6535947712418301s"></animate> <animate attributeName="r" values="9;1.8;9;1.8;9" keyTimes="0;0.25;0.5;0.75;1" dur="1.9607843137254901s" repeatCount="indefinite" begin="0.6535947712418301s"></animate> </circle><circle cx="46.3863" cy="63.4865" r="6.4833" fill="url(#bc2)"> <animate attributeName="cx" values="45.60007623325715;54.399923766742845;45.60007623325715" keyTimes="0;0.5;1" dur="1.9607843137254901s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" repeatCount="indefinite" begin="0.32679738562091504s"></animate> <animate attributeName="cy" values="66.42073904691416;33.579260953085836;66.42073904691416" keyTimes="0;0.5;1" dur="1.9607843137254901s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" repeatCount="indefinite" begin="0.32679738562091504s"></animate> <animate attributeName="r" values="9;1.8;9;1.8;9" keyTimes="0;0.25;0.5;0.75;1" dur="1.9607843137254901s" repeatCount="indefinite" begin="0.32679738562091504s"></animate> </circle><circle cx="50.3802" cy="49.8981" r="1.9167" fill="url(#bc2)"> <animate attributeName="cx" values="33.579260953085836;66.42073904691416;33.579260953085836" keyTimes="0;0.5;1" dur="1.9607843137254901s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" repeatCount="indefinite" begin="0s"></animate> <animate attributeName="cy" values="54.39992376674286;45.60007623325715;54.39992376674286" keyTimes="0;0.5;1" dur="1.9607843137254901s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" repeatCount="indefinite" begin="0s"></animate> <animate attributeName="r" values="9;1.8;9;1.8;9" keyTimes="0;0.25;0.5;0.75;1" dur="1.9607843137254901s" repeatCount="indefinite" begin="0s"></animate> </circle> </svg> &nbsp; Chargement...');
                multievwait=1;
            }else{
                $('.fdpop,.contblocevents').fadeIn(500);
                $('.blocevents').css({'opacity':'0.8','transform':'scale(1.0)'});
                $('.titpast').css({'opacity':'1','transform':'scale(1.0)'});
                multievwait=0;
                $('.multievbtn').removeClass('multievbtnclic').html('<i class="fal fa-bars"></i> &nbsp; Mes listes de contrôle');
            };
        };
        $('.filterme').change(function(){
            $('.blocevents').addClass('bloceventOff');
            $('.titpast').fadeOut(0);
            if($(this).val()=='All'){
                $('.bloceventOnline').removeClass('bloceventOff');
                $('.bloceventWaiting').removeClass('bloceventOff');
                $('.bloceventPast').removeClass('bloceventOff');
                $('.titpast').fadeIn(0);
            }else if($(this).val()=='Flag'){
                $('.bloceventFlag').removeClass('bloceventOff');
            }else if($(this).val()=='Actif'){
                $('.bloceventOnline').removeClass('bloceventOff');
            }else if($(this).val()=='Inactif'){
                $('.bloceventWaiting').removeClass('bloceventOff');
            }else if($(this).val()=='Expired'){
                $('.bloceventPast').removeClass('bloceventOff');
            };
        });
        $('.btnmodafme').click(function(){
            var modaf=$(this).attr('mod');
            $('.confremoveme').css({'transition-duration':'0.4s'});
            if(modaf=='inline'){
                $('.blocevents').removeClass('blocevinline').addClass('blocevinblock');
                $('.icmodafme').html('<i class="fa-solid fa-bars"></i>');
                $(this).attr('mod','inblock');
                $('.titpast').addClass('titpastinblock');
                setTimeout(function(){
                    $('.confremoveme').css({'transition-duration':'0.0s'});
                },400);
            }else{
                $('.blocevents').removeClass('blocevinblock').addClass('blocevinline');
                $('.icmodafme').html('<i class="fa-solid fa-rectangle-history"></i>');
                $(this).attr('mod','inline');
                $('.titpast').removeClass('titpastinblock');
                setTimeout(function(){
                    $('.confremoveme').css({'transition-duration':'0.0s'});
                },400);
            };
        });
        $('.addevbtn').click(function(){
            $('.fdpop,.blocaddevent').fadeIn(500);
        });
        $('.decobtn').click(function(){
            $('.fdpop,.bloconfdeco').fadeIn(600);
        });
        $('.fdpop,.btncloseme,.closepopadevent').click(function(){
            if(checlic==0){
                $('.blocaddevent').fadeOut(500);
            };
            $('.confremoveme').fadeOut(400);
            $('.btnremoveme').removeClass('cbtnremoveme').html('<i class="fas fa-trash-alt"></i>');
            $('.fdpop,.bloconfdeco,.contblocevents').fadeOut(500);
            $('.blocevents').css({'opacity':0.0,'transform':'scale(0.9)'});
            $('.titpast').css({'opacity':0.0,'transform':'scale(0.9)'});
            setTimeout(function(){
                $('.blocevents:eq(0)').css({'opacity':1.0,'transform':'scale(1.0)'});
            },500);
        });
        $('.btnconfdeco,.decobtn2').click(function(){
            $(this).html('Chargement...');
            userDeco();
        });
        function userDeco(){
            localStorage.setItem('authUser','false');
            localStorage.setItem('idUser','');
            localStorage.setItem('infoUser','');
            localStorage.setItem('dataList','');
            localStorage.setItem('dataAllLists','');
            $('.fdpop,.bloconfdeco').fadeOut(0);
            $('.btnconfdeco,.decobtn2').html('Confirmer');
            t.ngZone.run(()=>t.router.navigate(['login']));
        };
        var menuop=0;
        $('#iconclosemenu, .logoheaderbo, .testtt, .desec').click(function(){
            var wiwi= $(window).width();
            menuop=parseInt($('.menubo').attr('id'));
            if(menuop==1){
                $('.menubo').attr('id','0');
                $('.bloCont').css({'margin-left':'70px'});
                $('.desec').css({'left':'70px'});
                $('.logowilout0').css({'transform':'rotate(180deg)'});
                $('.logowilout').css({'fill':'#ffffff', 'transform':'rotate(180deg)'});
                $('.namewilout').fadeOut(250);
                $('.menubs0').css({'height':'1px'});
                $('.titleEvent, .statutEvent').fadeOut(300);
                $('.titsem').fadeOut(250);
                $('.menu2bo').css({'left':'70px', 'top':'0px'});
                $('.secmenu2bs').css({'height':'40','line-height':'35px'});
                $('.headmenu2bs').css({'display':'block'});
                $('.btncontact').css({'left':'10px'});
                $('.pop, .popaddevent').css({'margin-left':'35px'});
                $('.menu2bs-1').css({'background-image':'linear-gradient(130deg,#fe8a2b,#f85524)'});
                $('.menu2bs-2').css({'background-image':'linear-gradient(130deg,#fe842b,#f85524)'});
                $('.menu2bs-3').css({'background-image':'linear-gradient(130deg,#fd822a,#f85524)'});
                $('.menu2bs-4').css({'background-image':'linear-gradient(130deg,#fd7f29,#f85524)'});
                $('.menu2bs-5').css({'background-image':'linear-gradient(130deg,#fc7c2a,#f85524)'});
                $('.menu2bs-6').css({'background-image':'linear-gradient(130deg,#fb772a,#f85524)'});
                $('.menu2bs-7').css({'background-image':'linear-gradient(130deg,#fc7329,#f85524)'});
                $('.menu2bs-8').css({'background-image':'linear-gradient(130deg,#fb7128,#f85524)'});
                menuop = 0;
                if(wiwi>610){
                    $('.menubo').css({'width':'70px'});
                }else{
                    $('.menubo').css({'width':'0px'});
                    setTimeout(function(){
                        $('.menubo').css({'z-index':'190'});
                    },600);
                };
            }else{
                $('.menubo').attr('id','1').css({'z-index':'300'});
                $('.bloCont').css({'margin-left':'70px'});
                $('.logowilout0').css({'transform':'rotate(70deg)'});
                $('.desec').css({'left':'70px'});
                $('.logowilout').css({'fill':'#ffffff9f', 'transform':'rotate(0deg)'});
                $('.namewilout').fadeIn(550);
                $('.menubs0').css({'height':'110px'});
                $('.titleEvent, .statutEvent').fadeIn(300);
                $('.titsem').fadeIn(550);
                $('.menu2bo').css({'top':'109px'});
                $('.secmenu2bs').css({'height':'45px','line-height':'45px'});
                $('.headmenu2bs').css({'display':'none'});
                $('.btncontact').css({'left':'20px'});
                $('.pop, .popaddevent').css({'margin-left':'110px'});
                $('.menu2bs').css({'background-image':'linear-gradient(130deg,#ff8b2c,#f76e24'});
                if(wiwi>610){
                    $('.menubo').css({'width':'220px'});
                    $('.menu2bo').css({'left':'220px'});
                    $('.desec').css({'left':'220px'});
                    $('.bloCont').css({'margin-left':'220px'});
                }else{
                    $('.menubo').css({'width':'190px'});
                    $('.menu2bo').css({'left':'190px'});
                };
                menuop = 1;
            };
        });
        $('.menubs').click(function(){
            var turl=$(this).attr('url');
            if(checkTactile==0){
                t.ngZone.run(()=>t.router.navigate([turl]));
            };
        });
        var getsec;
        $('.menubs, .menu2bs').mouseover(function(){
            getsec = $(this).attr('tag').split('-');
            getsec=getsec[1];
            $('.menu2bs').css({'display':'none'});
            $('.menu2bs-'+getsec+'').css({'display':'block'});
            if(menuop==0){
                $('.menubs-'+getsec+'').addClass('mbhC');
                $('.menu2bo').css({'opacity':'1.0'});
            }else{
                $('.menubs-'+getsec+'').addClass('mbhO');
                $('.menu2bo').css({'opacity':'1.0'});
            };   
        });
        $('.menubs, .menu2bs').mouseout(function(){
            if(menuop==0){
                $('.menubs').removeClass('mbhC');
                $('.menu2bo').css({'opacity':'0.0'});
            }else{
                $('.menubs').removeClass('mbhO');
                $('.menu2bo').css({'opacity':'0.0'});
            };
            $('.menu2bs').css({'display':'none'});
        });
        $('.secmenu2bs').click(function(){
            var wiwi= $(window).width();
            if(wiwi<=610){
                menuop=0;
                $('.menubo').attr('id','0').css({'width':'0px'});
                $('.menu2bo').css({'left':'0px', 'top':'0px','opacity':'0.0'});
                $('.bloCont').css({'margin-left':'70px'});
                $('.desec').css({'left':'70px'});
                $('.logowilout0').css({'transform':'rotate(180deg)'});
                $('.logowilout').css({'fill':'#ffffff', 'transform':'rotate(180deg)'});
                $('.namewilout').fadeOut(250);
                $('.menubs').removeClass('mbhO');
                $('.menubs0').css({'height':'1px'});
                $('.titleEvent, .statutEvent').fadeOut(300);
                $('.titsem').fadeOut(250);
                $('.secmenu2bs').css({'height':'40','line-height':'35px'});
                $('.headmenu2bs').css({'display':'block'});
                $('.btncontact').css({'left':'10px'});
                $('.pop, .popaddevent').css({'margin-left':'35px'});
                $('.menu2bs').css({'background-image':'linear-gradient(to right,#db2c2f,#c3162e'});
                setTimeout(function(){
                    $('.menubo').css({'z-index':'190'});
                },600);
            };
        });
        $('.bar').focusin(function(){
            $(this).addClass('baron');
            $(this).parent().addClass('boxon');
        });
        $('.bar').focusout(function(){
            $(this).removeClass('baron');
            if($(this).val()!=""){
            }else{
                $(this).parent().removeClass('boxon');
            };
        });
        var dataNewList={
            name:'',
            dateEndValide:''
        };
        var di = new Date();
        var diyear=di.getFullYear();
        var dimonth=(di.getMonth())+1;
        var didate=di.getDate();
        var dihours=di.getHours();
        var diminutes=di.getMinutes();
        var diyearTxt=diyear.toString();
        var dimonthTxt='';if(dimonth<10){dimonthTxt='0'+dimonth.toString()}else{dimonthTxt=dimonth.toString()};
        var didateTxt='';if(didate<10){didateTxt='0'+didate.toString()}else{didateTxt=didate.toString()};
        var dihoursTxt='';if(dihours<10){dihoursTxt='0'+dihours.toString()}else{dihoursTxt=dihours.toString()};
        var diminutesTxt='';if(diminutes<10){diminutesTxt='0'+diminutes.toString()}else{diminutesTxt=diminutes.toString()};
        var dif=diyearTxt+'-'+dimonthTxt+'-'+didateTxt+'T'+dihoursTxt+':'+diminutesTxt;
        $('#indateAE').attr('min',dif);
        $("#innameAE").keyup(function(){
            dataNewList.name=$(this).val();
        });
        $("#innameAE").change(function(){
            $(this).removeClass('signalinvide').attr('placeholder','Titre');
        });
        $('#indateAE').change(function(){
            if($(this).val()!=''){
                var vd=$(this).val().split('T');
                var vd1=vd[0].split('-');
                vd1=vd1[2]+'-'+vd1[1]+'-'+vd1[0];
                var vd2=vd[1]+':00';
                dataNewList.dateEndValide=vd1+' '+vd2;
            };
            $(this).removeClass('signalinvide');
        });
        var checlic=0;
        $('.btnconfaddevent').click(function(event){
            event.stopPropagation();
            if(checlic==0){
                checlic=1;
                var checkobl=0;
                var re=/^[ t]*$/;
                if(dataNewList.name==''||dataNewList.name.match(re)){$('#innameAE').addClass('signalinvide').attr('placeholder','Ce champ est requis');checlic=0;checkobl=1};
                if(dataNewList.dateEndValide==''){$('#indateAE').addClass('signalinvide');checlic=0;checkobl=1};
                if(checkobl==0){
                    $(this).html('Chargement...<div class="loaderaddevent"></div>');
                    $('.loaderaddevent').animate({'width':50},100);
                    t.boService.createList(dataNewList).then((data) => {
                        var idevent = data['message'].id;
                        $('.loaderaddevent').animate({'width':150},100);
                        t.boService.getAllLists(idevent).then((data) => {
                            createOk();
                        }).catch(error => {
                            console.log('Erreur de chargement des données events ( '+error+' )');
                            checlic=0;$(this).html('<i class="fas fa-save"></i> &nbsp;Enregistrer');
                        });
                    }).catch(error => {
                        console.log('Erreur de création d\'un événement ( '+error.error.message+' )');
                        checlic=0;$(this).html('<i class="fas fa-save"></i> &nbsp;Enregistrer');
                    });
                };
            };
        });
        function createOk(){
            $('.loaderaddevent').animate({'width':250},100);
            $('.headae').fadeIn(0);
            dataNewList={
                name:'',
                dateEndValide:''
            };
            $('.inae').removeClass('signalinvide');
            $('#innameAE').val('').attr('placeholder','Titre');
            $('#indateAE').val('');
            $('.btnconfaddevent').html('<i class="fas fa-save"></i> &nbsp;Enregistrer');
            $('.loaderaddevent').css({'width':0});
            $('.fdpop,.fdpopstop,.blocaddevent').fadeOut(300);
            checlic=0;
            t.ngZone.run(()=>t.router.navigateByUrl('/redirect')).then(() => {
                t.ngZone.run(()=>t.router.navigate(['tableau-de-bord']));
            });
        };
    });

  };
}
